import axios from 'axios'

import {
	NOTIFICATIONS_SEEN,
	NOTIFICATION_OPENED,
	NOTIFICATIONS_CLEARED,
	TODODAY_ADDED,
	TODODAY_CHANGED,
} from './types'

import copy from 'fast-copy'

import { API_URL } from '../api'

export function joinAccount(account_id, user_id, callback) {
	return dispatch => {
		axios.post(API_URL + '/auth/joinAccount', { account_id, user_id })
			.then(response => {
				dispatch({
					type: 'ENTITY_ADDED_OR_UPDATED',
					payload: response.data,
					entityType: 'account',
				})

				callback()
			})
	}
}

export function refreshUserData(type, callback = null) {
	return dispatch => {
		axios.get(API_URL + '/auth/refresh?type=' + type)
			.then(response => {
				dispatch({
					type: 'ENTITY_ADDED_OR_UPDATED',
					payload: copy(response.data),
					entityType: 'user',
				})

				dispatch({
					type: 'HEADER_TAB_FINISHED_LOADING',
					payload: type
				})

				if (callback) {
					callback()
				}
			}).catch(error => {
				console.log(error)
			})
	}
}

export function registerHistory(objectId, type, extraData = null) {
	return dispatch => {
		axios.post(API_URL + '/user/registerHistory', { objectId, type, extraData })
	}
}

export function seeNotifications() {
	return dispatch => {
		axios.get(API_URL + '/notifications/see')

		dispatch({
			type: NOTIFICATIONS_SEEN,
		})
	}
}

export function setNotificationOpenStatus(notification) {
	return dispatch => {
		axios.post(API_URL + '/notifications/open', { notification })

		dispatch({
			type: NOTIFICATION_OPENED,
			payload: notification,
		})
	}
}

export function clearNotifications(notifications) {
	return dispatch => {
		axios.post(API_URL + '/notifications/clear')

		dispatch({
			type: NOTIFICATIONS_CLEARED,
			notifications: notifications,
		})
	}
}

export function getNotificationData(notificationId, callback) {
	return dispatch => {
		axios.get(API_URL + '/notifications/get?id=' + notificationId).then(response => {
			dispatch({
				type: 'NOTIFICATION_PENDED',
				payload: response.data
			})

			callback(response.data);
		}).catch(error => {

			dispatch({
				type: 'NOTIFICATION_PENDED',
				payload: {
					id: -1,
					invalid: true
				}
			})

			callback(null)
		})
	}
}

export const doActivate = (key, callback) => {
	return dispatch => {
		axios.get(API_URL + '/user/activate/' + key)
			.then(response => {
				dispatch({
					type: 'EMAIL_VALIDATED',
					payload: response.status
				})

				// window.Echo doesn't exist for a few seconds.
				setTimeout(_ => {
					if (window.Echo) {
						const user = response.data
						let userChannel = window.Echo.join('user_' + user.id)

						userChannel.whisper('activated', {
							user
						})
					}
				}, 3000)

				callback()
			}).catch(error => {
				const statusCode = error.response.status

				dispatch({
					type: 'EMAIL_VALIDATED',
					payload: statusCode
				})

				callback()
			})
	}
}

export const doUnsubscribe = (data, callback) => {
	return dispatch => {
		axios.post(API_URL + '/user/unsubscribe', data)
			.then(response => {
				dispatch({
					type: 'UNSUBSCRIBED',
					payload: data.type
				})

				if (callback) {
					callback()
				}
			}).catch(error => {
				console.log(error)
			})
	}
}

export const clearActivation = _ => {
	return dispatch => {
		dispatch({
			type: 'EMAIL_VALIDATION_CLEARED',
		})
	}
}

export const resendActivation = _ => {
	return dispatch => {
		axios.post(API_URL + '/user/resendActivation')
	}
}

// Todos
export function changeTodoDay(index) {
	return dispatch => {
		dispatch({
			type: TODODAY_CHANGED,
			index: index
		})
	}
}

export function createTodoDay(data) {
	return dispatch => {
		axios.post(API_URL + '/todos/createDay', { data }).then(response => {
			if (response.data.id) {
				dispatch({
					type: TODODAY_ADDED,
					payload: response.data
				})

				dispatch({
					type: 'ENTITY_ADDED_OR_UPDATED',
					payload: response.data,
					entityType: 'todoDay',
				})
			}
		})
	}
}

export function createTodo(name = null, order, callback, task_id = null) {
	return dispatch => {
		dispatch({
			type: 'HEADER_TAB_CHANGED',
			payload: 'todos'
		})

		dispatch({
			type: 'OPTIMISTIC_TODO',
			payload: {
				id: -1,
				order: -1,
				task_id,
				text: name,
				is_checked: 0,
			}
		})

		axios.post(API_URL + '/todos/create', { name, order, task_id }).then(response => {
			if (response.data.id) {
				dispatch({
					type: 'OPTIMISTIC_TODO',
					payload: null
				})

				dispatch({
					type: 'ENTITY_ADDED_OR_UPDATED',
					payload: response.data,
					entityType: 'todoDay',
				})

				callback()
			}
		}).catch(error => {
			console.log(error);
		});
	}
}

export function updateTodo(todo) {
	return dispatch => {
		axios.post(API_URL + '/todos/update', { todo }).catch(error => {
			console.log(error)
		})

		dispatch({
			type: 'ENTITY_ADDED_OR_UPDATED',
			payload: todo,
			entityType: 'todo',
		})
	}
}

export function deleteTodo(todo, callback) {
	return dispatch => {
		axios.post(API_URL + '/todos/delete', { todo }).then(response => {
			if (response.data.id) {
				dispatch({
					type: 'ENTITY_DELETED',
					entityType: 'todo',
					parentType: 'todo_day',
					payload: response.data,
				})
			} else {
				console.log('dang!');
			}

			if (typeof callback !== 'undefined') {
				callback()
			}

		}).catch(error => {
			console.log(error);
		})
	}
}

export function updateTodoOrder(todos) {
	return dispatch => {
		axios.post(API_URL + '/todos/updateOrder', { todos }).then(response => {
		}).catch(error => {
			console.log(error)
		})

		dispatch({
			type: 'ENTITY_ADDED_OR_UPDATED',
			payload: todos,
			entityType: 'todo',
			isArray: true,
			overwriteMerge: true
		})
	}
}

export function clearPending() {
	return dispatch => {
		dispatch({
			type: 'CLEARED_PENDING',
		})
	}
}

export function reassignGuestProjects(data, type) {
	return dispatch => {
		dispatch({
			type: 'ENTITY_ADDED_OR_UPDATED',
			payload: {
				id: data.id,
				projectIds: data.projectIds
			},
			entityType: type,
		})

		axios.post(API_URL + '/user/reassignGuestProjects', { data, type })
			.then(response => {
				dispatch({
					type: 'ENTITY_ADDED_OR_UPDATED',
					payload: response.data,
					entityType: 'project',
					isArray: true
				})
			})
			.catch(error => {
				console.log(error)
			})
	}
}

export const getTeamMemberData = (userId, timeOnly, callback) => {
	return dispatch => {
		axios.get(API_URL + '/user/' + userId + (timeOnly ? '?timeOnly' : ''))
			.then(response => {
				dispatch({
					type: 'ENTITY_ADDED_OR_UPDATED',
					payload: response.data,
					entityType: 'user',
					isArray: true
				})

				callback()
			})
			.catch(error => {
				console.log(error)
			})
	}
}

export const sendFeedback = (text, accountId, callback) => {
	return dispatch => {
		axios.post(API_URL + '/user/sendFeedback', { text, accountId }).then(response => {
			callback()
		})
	}
}

export const updateOrganisationOrder = (orderArray, user) => {
	return dispatch => {
		const updatedUser = {
			...user,
			organisation_order: orderArray,
		}

		dispatch({
			type: 'ENTITY_ADDED_OR_UPDATED',
			payload: updatedUser,
			entityType: 'user'
		})

		axios.post(`${API_URL}/user/organisationOrder`, { orderArray })
			.catch(error => {
				console.log(error)
			})
	}
}

export const setFavouritesVisibility = isVisible => {
	return dispatch => {
		dispatch({
			type: 'SET_FAVOURITES_VISIBILITY',
			payload: isVisible
		})
	}
}

export const setOnboardingStep = (type, user) => {
	return dispatch => {
		const onboarded_enums = user.onboarded_enums ? [...user.onboarded_enums] : []

		if (onboarded_enums.indexOf(type) === -1) {
			onboarded_enums.push(type)
		}

		dispatch({
			type: 'ENTITY_ADDED_OR_UPDATED',
			payload: {
				...user,
				onboarded_enums
			},
			entityType: 'user'
		})

		dispatch({
			type: 'SET_ONBOARDED_ENUM',
			payload: type
		})

		axios.post(`${API_URL}/user/setOnboardingStep`, { type })
			.catch(error => {
				console.log(error)
			})
	}
}

export const resetInstructions = user => {
	return dispatch => {
		dispatch({
			type: 'ENTITY_ADDED_OR_UPDATED',
			payload: {
				...user,
				onboarded_enums: []
			},
			entityType: 'user'
		})

		dispatch({
			type: 'CLEAR_ONBOARDED_ENUMS',
		})

		axios.post(`${API_URL}/user/clearOnboardingSteps`)
	}
}

export const checkForNewChats = _ => {
	return dispatch => {
		axios.get(`${API_URL}/user/checkForNewChats`)
			.then(response => {
				if (response.data.length) {
					dispatch({
						type: 'ENTITY_ADDED_OR_UPDATED',
						payload: response.data,
						entityType: 'chatItem',
						isArray: true
					})
				}
			}).catch(error => {
				console.log(error)
			})
	}
}

export const updateUserSubscriber = data => {
	return () => {
		axios.post(`${API_URL}/user/updateUserSubscriber`, { data })
	}
}

export const setStatus = (user, statusKey) => {
	return dispatch => {
		dispatch({
			type: 'ENTITY_ADDED_OR_UPDATED',
			payload: {
				...user,
				status_if_online: statusKey
			},
			entityType: 'user'
		})

		axios.post(`${API_URL}/user/setStatus`, {
			statusKey
		})
	}
}